/*
  Fabric Guide Promo — scroll-reveal animation.
  No dependencies. If this script fails to load for any reason, the
  section's CSS transition simply never triggers and it stays fully
  visible via the no-JS fallback below — nothing breaks.
*/
document.addEventListener('DOMContentLoaded', function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sections = document.querySelectorAll('.fgpromo');

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    sections.forEach(function (el) { el.classList.add('is-visible'); });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  sections.forEach(function (el) { observer.observe(el); });
});
